module.exports = __webpack_public_path__ + "412aaf5a3e0fff7c9c7207bf2fc610b3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/sleeping-7.png
// module id = 2268
// module chunks = 0